import styled from 'styled-components'

import { helpers } from '../../../styles/theme'

type Props = {
	isSmall?: boolean
}

export const RowLabel = styled.label<Props>`
	display: grid;
	grid-template-columns: min-content 1fr;
	column-gap: 8px;
	color: ${helpers.color.text};
	font-size: ${({ isSmall = false }) => (isSmall ? '12px' : '15px')};
	line-height: ${({ isSmall = false }) => (isSmall ? '1' : 'unset')};
	font-family: ${helpers.font.family.header};
	margin: 0;
	position: relative;
	width: fit-content;

	> label {
		margin-bottom: 0;
		align-self: center;
	}
`
